import React, { useEffect, useState } from "react";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Title from "./Title";

function preventDefault(event: any) {
  event.preventDefault();
}

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function Users() {
  const classes = useStyles();
  const [userData, setUserData] = useState<any>([]);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    let response = await fetch("/api/users");
    let users = await response.json();

    if (users.success) {
      setUserData(users.result);
    } else {
      setUserData([]);
    }
  };

  return (
    <React.Fragment>
      <Title>Recent Users</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Username</TableCell>
            <TableCell>Currency</TableCell>
            <TableCell align="right">Balance (Cash)</TableCell>
            <TableCell align="right">Balance (Bonus)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {userData.map((row: any) => (
            <TableRow key={row._id}>
              <TableCell>{row.username}</TableCell>
              <TableCell>{row.wallet.currency}</TableCell>
              <TableCell align="right">{row.wallet.balance.cash}</TableCell>
              <TableCell align="right">{row.wallet.balance.bonus}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className={classes.seeMore}>
        <Link color="primary" href="#" onClick={preventDefault}>
          See all users
        </Link>
      </div>
    </React.Fragment>
  );
}
